import { ConfigOptions } from "../types";

export const sliceShownOtherItems = <T extends unknown[]>(
  data: T,
  options: ConfigOptions = {},
  showMore?: boolean,
): T => {
  const { shownItems, otherItems } = options;
  const limit = shownItems && otherItems ? Math.min(shownItems, otherItems) : shownItems || otherItems;

  return (shownItems || otherItems) && !showMore ? ((data?.slice(0, limit) || []) as T) : data;
};
